import React from 'react';

type CardContentProps = {
    children: React.ReactNode;
    className?: string;
};

const CardContent: React.FC<CardContentProps> = ({children, className = ''}) => {
    return (
        <div className={`mt-4 ${className}`}>
            {children}
        </div>
    );
};

export default CardContent;
